import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/Authcontext";
import search from "../assets/searsh.svg";

const Forums = () => {
  const { id } = useParams();
  const [rooms, setrooms] = useState([]);
  const [flrooms, setflrooms] = useState([]);
  const [didsearch, setdidsearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message
  const [notfound, setnotfound] = useState(""); // new state variable for error message
  const [refresh, setrefresh] = useState(""); // new state variable for error message

  const { contextData } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    userisinforums();
    getrooms();
  }, []);

  const getrooms = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/rooms/${id}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setrooms(responce.data);
  };

  const userisinforums = async () => {
    let responce;
    if (contextData.user) {
      try {
        responce = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/user/formation/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${contextData.authTokens.access}`,
            },
          }
        );
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setErrorMessage(
            "Sorry, there was a problem with the server. Please try again later."
          );
        }
        return;
      }
      if (!responce.data) {
        navigate("/notallowed");
      }
    } else {
      navigate("/notallowed");
    }
  };

  // const handelsearchforum = async (e) => {
  //   e.preventDefault();
  //   const search=e

  //   let responce;
  //   try {
  //     responce = await axios.get(`https://pfebackend-zbz0.onrender.com/api/room/filter/${id}/${search}/`);

  //   } catch (error) {
  //     if (error.response && error.response.status === 500) {

  //       setErrorMessage("Sorry, there was a problem with the server. Please try again later.");
  //     }
  //     return

  //   }

  //   setflrooms(responce.data);
  //   setdidsearch(true)
  // };

  const handelsearchforum = async (e) => {
    if (e !== "") {
      const search = e;
      let responce;
      try {
        responce = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/room/filter/${id}/${search}/`
        );
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setErrorMessage(
            "Sorry, there was a problem with the server. Please try again later."
          );
        }
        return;
      }

      setrooms(responce.data);

      if (responce.data.length === 0) {
        setnotfound(true);
      } else {
        setnotfound(false);
      }

      setrefresh(!refresh);
    } else {
      getrooms();
    }
  };

  const handeldeletesearch = () => {
    setflrooms([]);
    setdidsearch(false);
    setSearchValue("");
  };

  return (
    <>
      <div className="forum-header">
        <h2>Forums</h2>

        <Link className="custom-link" to={`/formation/${id}/createroom`}>
          new forum
        </Link>
      </div>
      {errorMessage && <div className=" erroremailexiste">{errorMessage}</div>}

      <div className="searchcontainer searchcontainer-forum ">
        <input
          type="text"
          placeholder="Find a training"
          className="search-input"
          onInput={(event) => handelsearchforum(event.target.value)}
        />
        <div className="search-image-container">
          <img className="search-image" src={search} alt="" />
        </div>
      </div>

      <hr />

      {didsearch && flrooms.length === 0 && (
        <div className="alert alert-danger" role="alert">
          no forums found
        </div>
      )}

      {rooms.map((e, i) => (
        <Link
          className="custom-link custom-link-forum"
          key={i}
          to={`/formation/${id}/rooms/${e.id}`}
        >
          <p className="custom-link-forump">{e.name}</p>
          <p>{e.description.substring(0, 70)}</p>
        </Link>
      ))}
    </>
  );
};

export default Forums;
